import styled from 'styled-components';

import { Text } from '@/nova/components';
import { cardHover } from '@/nova/theme/configurator-keyframes';
import { CFG, CFG_CHROME } from '../../../../../theme/configurator-tokens';

export const Footer = styled.footer`
  position: sticky;
  bottom: 0;
  z-index: 20;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 16px;
  border-radius: 0 0 20px 20px;
  border-top: 1px solid ${CFG_CHROME.sidebarBorder};
  padding: 16px;
  /* Frosted glass: a transparentish fill + a directional −45° light sheen sitting
     over a blurred backdrop (the step content that scrolls beneath the docked
     footer). The blur (Figma "Frost") + saturate (Refraction) ride on
     backdrop-filter; the inset highlight is the lit top edge ("Light" 80%). */
  background-color: ${CFG_CHROME.dockGlassBg};
  background-image: ${CFG_CHROME.dockGlassSheen};
  box-shadow: inset 0 1px 0 0 ${CFG_CHROME.dockGlassHighlight};
  backdrop-filter: blur(18px) saturate(140%);
  -webkit-backdrop-filter: blur(18px) saturate(140%);
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const BackButton = styled.button`
  display: flex;
  height: 40px;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 9999px;
  border: 1px solid ${CFG_CHROME.buttonBorder};
  background: transparent;
  padding: 0 16px;
  font-size: 14px;
  font-weight: 500;
  color: ${CFG.base200};
  transition: background-color 150ms ease;

  /* Cursor-following hover glow + lit hairline ring (shared with the CTA Button). */
  ${cardHover}

  &:hover {
    background: ${CFG.wash};
  }
`;

export const NextButton = styled.button`
  display: flex;
  height: 40px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 9999px;
  border: none;
  background: ${CFG.brand};
  padding: 0 16px;
  font-size: 14px;
  font-weight: 500;
  color: ${CFG_CHROME.ctaText};
  transition: opacity 150ms ease;
  cursor: pointer;

  /* Cursor-following hover glow + lit hairline ring (shared with the CTA Button). */
  ${cardHover}

  &:disabled:hover::before,
  &:disabled:hover::after,
  &:disabled:focus-visible::before,
  &:disabled:focus-visible::after {
    opacity: 0;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
  &:not(:disabled):hover {
    opacity: 0.9;
  }
`;

export const ButtonText = styled(Text)`
  display: inline;
`;
